import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=3a3b7fef"
import script from "./SearchForm.ts?vue&type=script&lang=ts&external"
export * from "./SearchForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports